import { getViewportSizeName } from '../util/general-util';
import ScrollStick from '../util/scroll-stick';

class GridQuickNav {
    constructor() {
        this.quickNavEl = document.querySelector('.quick-nav');
        this.gridFilterEl = document.querySelector('.grid-filters');
        this.gridTemplateEl = document.querySelector('.page-template-page-grid');

        this.gridStickyEl = this.quickNavEl ? this.quickNavEl : this.gridFilterEl;

        const blockChartEls = Array.from(document.querySelectorAll('.block-chart'));
        
        setTimeout(() => {
            let lastEl = blockChartEls.slice(-1)[0];
            let rect = lastEl.getBoundingClientRect();
            let blocksBottom = rect.bottom;
        }, 3000);

        if(this.gridTemplateEl) {
            this.initSticky();
        }

        window.addEventListener('resize', () => {
            const viewportSizeName = getViewportSizeName();

            if (this.lastViewportSizeName !== viewportSizeName) {
                this.lastViewportSizeName = viewportSizeName;

                this.initSticky();
            }
        });
    }

    initSticky() {
        let topSpacing = 0;

        if (this.lastViewportSizeName === 'medium') {
            topSpacing = 0;
        } else if (this.lastViewportSizeName === 'large') {
            topSpacing = 0;
        }

        if (this.quickNavSticky) {
            this.quickNavSticky.setTopTriggerOffset(topSpacing);
        } else {
            this.quickNavSticky = new ScrollStick(this.gridStickyEl, topSpacing);
        }
    }
}

export default GridQuickNav;